import {Component, Input} from '@angular/core';
import {ActionColumn} from '../../model/column/action-column';

@Component({
  selector: 'nc-action-cell',
  templateUrl: './nc-action-cell.component.html',
  styleUrls: ['./nc-action-cell.component.scss']
})
export class NcActionCellComponent {
  @Input() column: ActionColumn;
  @Input() rowData: any;

  constructor() {
  }

  onClick = (event): void => {
    event.stopPropagation();
    this.column.onClick(this.rowData);
  }

  getIcon() {
    return this.column.iconConfig.multipleIcons[this.rowData[this.column.iconConfig.checkField].toLowerCase()];
  }
}
